
<template>
  <div class="rechargeBox">
    <div class="hander">
      <van-icon name="arrow-left" @click="goBack" class='nav_goback' />
    </div>
    
    <div class="myMoney">
      <span class="t1">余额</span>
      <span class="t2">￥{{ balance }}</span>
    </div>
    <div class="recharge">
      <div class="t1">充值金额</div>
      <input type="number" placeholder="请输入金额" v-model="money" maxlength="6" />
    </div>
    <div class="btn" @click="rech">立即充值</div>
  </div>
</template>

<style lang="less" scoped>
.hander{
        width: 55px;
        height: 55px;
        border-radius: 50%;
        background-color: rgba(255,255,255,.6);
        margin-bottom: 10px;
      }
.rechargeBox {
  .myMoney {
    width: 100%;
    height: 98px;
    box-sizing: border-box;
    padding: 0 24px;
    display: flex;
    align-items: center;
    background: #fff;
    .t1 {
      font-size: 28px;
      color: #333;
      margin-right: 32px;
    }
    .t2 {
      font-size: 32px;
      color: #e42129;
    }
  }
  .recharge {
    width: 100%;
    height: 170px;
    padding: 35px 20px;
    margin-top: 20px;
    box-sizing: border-box;
    background-color: #fff;
    .t1 {
      font-size: 28px;
      color: #333;
    }
    input {
      font-size: 24px;
      color: #333;
      display: block;
      margin-top: 30px;
      border: none;
      width: 100%;
    }
  }
  .btn {
    width: 702px;
    height: 94px;
    border-radius: 10px;
    text-align: center;
    line-height: 94px;
    color: #fff;
    font-size: 32px;
    display: block;
    margin: 70px auto;
    border: none;
    background-color: #e42129;
  }
}
</style>
<script>
export default {
  data() {
    return {
      balance: 0,
      money: ""
    };
  },
  created() {
    this.balance = this.$route.params.balance || 0.0;
    let url = location.href.split("#")[0];
    this.$http({
      url: "jsApi",
      data: {
        url,
        url2: location.href
      }
    }).then(res => {
      this.$wx.config({
        debug: false,
        appId: res.jsdata.appId,
        timestamp: res.jsdata.timestamp,
        nonceStr: res.jsdata.nonceStr,
        signature: res.jsdata.signature,
        jsApiList: ["chooseWXPay"]
      });
    });
  },
  methods: {
    // 充值
    rech() {
      let reg = /^[1-9]\d*$/;
      let money = this.money;

      if (!reg.test(money)) return this.$toast("请输入正确的数字");
      if(Math.floor(money) > 1000000 ) return this.$toast('充值金额最大1000万')
      this.$http({
        url: "payForRecharge",
        data: {
          money
        }
      }).then(res => {
        this.$wx.chooseWXPay({
          timestamp: res.timeStamp, 
          nonceStr: res.nonceStr,
          package: res.package, 
          signType: res.signType, 
          paySign: res.paySign,
          success: pay=> {
            setTimeout(() => {
                this.$router.go(-2)
            }, 1500);
          }
        });
      });
    }
  }
};
</script>